import {
  accountsService,
  targetService,
  utilities,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

export class AvailableTargetsViewModel {

  isLoading = false;
  isRefreshingTargets = false;

  /** @type {import('./RoutingPlansViewModel').RoutingPlansViewModel} */
  context = null;

  targets = [];
  hasAnyTarget = false;

  /** @type {{ type: 'new-target' } | { type: 'new-target-route', target }} */
  modal = null;

  initialize(ctx) {
    this.context = ctx;

    this._loadTargets(false);

    return this;
  }

  async _loadTargets(silent = true) {

    if (!silent) {
      this.isLoading = true;
    }

    try {
      const targets = await targetService.getTargets(accountsService.currentAccountId, true);
      this.hasAnyTarget = targets.length > 0;

      //this.targets = $filter('notInCampaignRoutes')(targets, vm.routeContainerRoutes, 'target');
      this.targets = this.context.routeContainer?.routes
        ? targets.filter(target => !this.context.routeContainer.routes.find(route => route.callTarget.id === target.id))
        : targets;

    } catch (error) {
      utilities.errorHandler(error);
    } finally {
      this.isLoading = false;
    }
  }

  refreshTargets() {
    this.isRefreshingTargets = true;
    try {
      this._loadTargets();
    } finally {
      setTimeout(() => {
        this.isRefreshingTargets = false;
      }, 600);
    }
  }

  openNewTargetModal() {
    this.modal = { type: 'new-target' };
  }

  openNewTargetRouteModal = (target) => {
    this.modal = { type: 'new-target-route', target };
  };

  closeModal = () => {
    this.modal = null;
  };
}
